import { Component } from '@angular/core';
import { Alert } from '@models/alert';

import { AlertService } from '@services/alert.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'mdk-alert-modal',
  templateUrl: './alert-modal.component.html'
})
export class AlertModalComponent {
  public alert$: BehaviorSubject<Alert | null>;

  constructor(private alertService: AlertService) {
    this.alert$ = this.alertService.alert$;
  }

  onCloseAlert(): void {
    this.alertService.close();
  }
}
